import { createSelector } from '@reduxjs/toolkit';

import { PendingChange } from '@/shared/config';

import { RootState } from '@/app/model/store';

const selectToothNumberEditState = (state: RootState) => state.toothNumberEdit;

export const selectPendingChanges = createSelector(
  [selectToothNumberEditState],
  (state) => state.pendingChanges,
);

export const selectSelectedTooth = createSelector(
  [selectToothNumberEditState],
  (state) => state.selectedTooth,
);

export const selectHasPendingChanges = createSelector(
  [selectPendingChanges],
  (changes) => changes.length > 0,
);

export const selectPendingChangeByToothId = (toothId: string) =>
  createSelector([selectPendingChanges], (changes) =>
    changes.find((change: PendingChange) => change.tooth.toothID === toothId),
  );
